<template>
  <div class="sub-ger-clu-usu"> 
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- LIBERA O STATUS DA PAGINA -->
    <div v-else-if='statusGeral === ""'>
      <div>
        <App-Tabela
        :cpntColuna="colunas"
        :cpntLinha="linhas.adm"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário Administrador
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>

        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>

      <div>
        <App-Tabela
        :cpntColuna="colunas"
        :cpntLinha="linhas.pdr"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário Padrão
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>
        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>

      <div>
        <App-Tabela
        :cpntColuna="colunas"
        :cpntLinha="linhas.pdv"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário PDV
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>
        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>

      <div style="opacity: 0.75;">
        <App-Tabela 
        :cpntColuna="colunas"
        :cpntLinha="linhas.blo"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário Bloqueado
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>
        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>

      <div style="opacity: 0.75;">
        <App-Tabela 
        :cpntColuna="colunas"
        :cpntLinha="linhas.exc"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário Excluído
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>
        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>

      <div style="opacity: 0.75;">
        <App-Tabela 
        :cpntColuna="colunas"
        :cpntLinha="linhas.ind"
        ref="tabela">
        <template slot="titulo">
          <div class="sub-ger-clu-usu--titulo">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
            Usuário Indefinidos
            <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
          </div>
        </template>
        <template v-slot:col_usuario="{ valor }">
          <!-- SETA O NOME DO USUARIO -->
          <span v-html="valor"></span>
          
          <!-- SETA O BOTÃO COPIAR -->
          <App-Button :cpntIcone="'copiar'" @onClick="() => { subGerCluUsuCopiarConta(valor + '@' + cpntClu) }" :title="'Clique aqui para copiar o nome da conta para área de transferência.'"></App-Button>
        </template>
        </App-Tabela>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .sub-ger-clu-usu > div > div {
    background: #e9e9e9;
    border: 1px solid #ccc;
    padding: 5px;
    margin: 10px 0px;
    border-radius: 5px;
  }
  .sub-ger-clu-usu > div > div:first-child {
    margin-top: 0px;
  }
  .sub-ger-clu-usu > div > div:last-child {
    margin-bottom: 0px;
  }
  .sub-ger-clu-usu > div > div > table:not(:first-child) {
    margin-top: 10px;
  }
  .sub-ger-clu-usu--titulo {
    font-size: 13px;
    text-align: center;
    font-weight: bold;
  }
</style>

<style>
  .sub-ger-clu-usu > div > div > table > tbody > tr > td > div > span > button {
    padding: 2px 4px;
    margin-left: 5px;
  }
</style>

<script>
  export default {
    props: {
      cpntClu: {
        require: true
      },
      cpntUsuarios: {
        require: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [
          { mPer: 2,    chave: 'id_usu',    nome: 'Cód.'      },
          { mPer: 2,    chave: 'usuario',   nome: 'Usuário'   },
          // { mPer: 1,    chave: 'nome',      nome: 'Nome'      },
          // { mPer: 1,    chave: 'tel',       nome: 'Telefone'  },
          { mPer: 1,    chave: 'email',     nome: 'E-mail'    },
        ],
        linhas: {
          adm: [],
          pdr: [],
          pdv: [],
          blo: [],
          exc: []
        }
      }
    },
    mounted: function () {
      this.subGerCluUsuIniciar()
    },
    methods: {
      subGerCluUsuIniciar: function () {
        // SETA O STATUS DA TELA
        this.subGerCluUsuSetarStatusGeral('carregando')

        // MANDA BUSCAR OS USUARIOS DA LICENÇA DE USO
        this.subGerCluUsuCarregarDadosUsuario(() => { this.subGerCluUsuSetarStatusGeral('') })
      },
      subGerCluUsuSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subGerCluUsuCarregarDadosUsuario: function (callback) {
        // SETA OS USUARIOS ADM
        this.linhas.adm = JSON.parse(JSON.stringify(this.cpntUsuarios.administrador.data))

        // SETA OS USUARIOS PADRÕES
        this.linhas.pdr = JSON.parse(JSON.stringify(this.cpntUsuarios.padrao.data))

        // SETA OS USUARIOS PDV
        this.linhas.pdv = JSON.parse(JSON.stringify(this.cpntUsuarios.pdv.data))

        // SETA OS USUARIOS BLOQUEADOS
        this.linhas.blo = JSON.parse(JSON.stringify(this.cpntUsuarios.bloqueado.data))

        // SETA OS USUARIOS EXCLUIDOS
        this.linhas.exc = JSON.parse(JSON.stringify(this.cpntUsuarios.excluido.data))

        // SETA OS USUARIOS INDEFINIDOS
        this.linhas.ind = JSON.parse(JSON.stringify(this.cpntUsuarios.indefinido.data))

        // EXECUTA O CALLBACK RECEBIDO
        callback()
        // // SETA A QUERYGET QUE DEVE UTILIZAR
        // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // // SETA OS CAMPOS QUE DEVE RETORNAR
        // queryGet.field = {}

        // // FAZ A BUSCA DOS REGISTROS NA API
        // this.$store.state.comunicaAPI('/usuario/get', 'POST', queryGet, (retorno) => {
        //   // SETA OS VALORES ENCONTRADOS
        //   this.linhas.adm = retorno.data.filter(item => item.status === '1' && item.bloqueado !== '1' && item.administrador === '1' && item.usu_pdv !== '1')
        //   this.linhas.pdr = retorno.data.filter(item => item.status === '1' && item.bloqueado !== '1' && item.administrador !== '1' && item.usu_pdv !== '1')
        //   this.linhas.pdv = retorno.data.filter(item => item.status === '1' && item.bloqueado !== '1' && item.usu_pdv === '1')
        //   this.linhas.blo = retorno.data.filter(item => item.status === '1' && item.bloqueado === '1')
        //   this.linhas.exc = retorno.data.filter(item => item.status !== '1')

        //   // EXECUTA O CALLBACK RECEBIDO
        //   callback()
        // }, this.subGerCluUsuSetarStatusGeral)
      },
      subGerCluUsuCopiarConta: function (conta) {
        this.$store.commit('FUN_COPIAR_VALOR', conta)
      }
    }
  }
</script>
